import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

// Mirrors the backend SelectableBankResponse (invoice-review.service.ts).
export interface SelectableBank {
  readonly id: string;
  readonly account_type: string | null;
  readonly bank_name: string;
  readonly bank_beneficiary: string;
  readonly iban_or_account: string;
  readonly swift: string | null;
  readonly intermediary_bank: string | null;
  readonly bank_address: string | null;
  readonly bank_country: string | null;
}

export function selectableBanksKey(invoiceId: string | null | undefined) {
  return ['invoice-selectable-banks', invoiceId] as const;
}

// The entity bank catalog selectable for this invoice's (entity, currency).
// Empty when the currency/entity is unresolved — the dropdown shows that state
// rather than erroring.
export function useSelectableBanks(invoiceId: string | null | undefined) {
  return useQuery<SelectableBank[]>({
    queryKey: selectableBanksKey(invoiceId),
    enabled: typeof invoiceId === 'string' && invoiceId.length > 0,
    queryFn: () =>
      apiRequest<SelectableBank[]>(
        `/invoices/${encodeURIComponent(invoiceId ?? '')}/selectable-banks`,
      ),
  });
}
